export default __webpack_public_path__ + "static/media/car_forest_road.dd95e2c0.jpg";